import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../Utility';

export const initialState = {
  error: null,
  message: null,
  addEditError: null,
  addEditSuccess: null,
  addEditLoading: false,
  data: [],
  roleDetailLoading: false,
  roleDetailError: null,
  roleDetailData: null,
  defaultRolePermissionData: {},
  moduleList: [],
  moduleError: null,
  moduleLoading: false,
};

const moduleListSuccess = (state, action) => ({
  ...state,
  moduleList: action.data,
  moduleError: null,
  moduleLoading: false,
});

const moduleListFail = (state, action) => ({
  ...state,
  moduleList: [],
  moduleError: action.error,
  moduleLoading: false,
});

const roleListStart = (state) =>
  updateObject(state, { error: null });

const roleListSuccess = (state, action) =>
  updateObject(state, { data: action.data, error: null });

const roleListFail = (state, action) =>
  updateObject(state, { error: action.error, data: [] });

const roleDetailFail = (state, action) =>
  updateObject(state, {
    roleDetailError: action.error,
    roleDetailData: initialState.defaultRolePermissionData,
    roleDetailLoading: false,
  });

const roleDetailSuccess = (state, { data }) => {
  let permissionsArray = [];
  if (data && data.Permission) {
    if (typeof data.Permission === "string") {
      permissionsArray = data.Permission.split(",");
    } else if (Array.isArray(data.Permission)) {
      permissionsArray = data.Permission;
    }
  }
  
  let moduleArray = [];
  if (data && data.Module) {
    if (typeof data.Module === "string") {
      moduleArray = data.Module.split(",");
    } else if (Array.isArray(data.Module)) {
      moduleArray = data.Module;
    }
  }

  const detail = data
    ? {
        ...data,
        Permission: permissionsArray,
        Module: moduleArray,
      }
    : initialState.defaultRolePermissionData;

  return updateObject(state, {
    roleDetailError: null,
    roleDetailData: detail,
    roleDetailLoading: false,
  });
};

const addEditStart = (state) =>
  updateObject(state, { addEditError: null, addEditSuccess: null, addEditLoading: true });

const addEditSuccess = (state, action) =>
  updateObject(state, { addEditSuccess: action.message, addEditLoading: false });

const addEditFail = (state, action) =>
  updateObject(state, { addEditError: action.error, addEditLoading: false });

const addEditSuccessMessage = (state, action) =>
  updateObject(state, { addEditSuccess: action.message, addEditLoading: false });

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ROLE_LIST_START:
      return roleListStart(state);
    case actionTypes.ROLE_LIST_SUCCESS:
      return roleListSuccess(state, action);
    case actionTypes.ROLE_LIST_FAIL:
      return roleListFail(state, action);
    case actionTypes.ROLE_ADD_EDIT_START:
      return addEditStart(state);
    case actionTypes.ROLE_ADD_EDIT_SUCCESS:
      return addEditSuccess(state, action);
    case actionTypes.ROLE_ADD_EDIT_FAIL:
      return addEditFail(state, action);
    case actionTypes.ROLE_ADD_EDIT_SUCCESS_MESSAGE:
      return addEditSuccessMessage(state, action);
    case actionTypes.ROLE_DETAIL:
    case actionTypes.ROLE_DETAIL_SUCCESS:
      return roleDetailSuccess(state, action);
    case actionTypes.ROLE_DETAIL_FAIL:
      return roleDetailFail(state, action);
    case actionTypes.MODULE_LIST_SUCCESS:
      return moduleListSuccess(state, action);
    case actionTypes.MODULE_LIST_FAIL:
      return moduleListFail(state, action);
    default:
      return state;
  }
};

export default reducer;
